/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { Column, Row } from '../../layout/components/dom'
import { useGlobal } from '../../utility/CTX'
import { useState } from 'react';
import { useEffect } from 'react';
import { useMostRecentItems, useTicketTypeColors } from '../../utility/hooks';
import { IButton, ICONMAP } from '../../layout/components/button';
import './roadmap.css';
import { Helmet } from 'react-helmet';












function Roadmap() {
    const { theme } = useGlobal();



    // alpha
    //  feature development and testing
    //  community feedback intake
    //  build out marketing channels
    //  tutorial videos and


    // beta
    //  vtt, campaign management
    //  local game servers
    //  

    // full release



        
    return <Column style={{ maxWidth: 600, margin: 'auto'}}>
        <Helmet>
          <title>Roadmap - Gateway Forge</title>
          <meta name="description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />
          <meta property="og:url" content="https://gatewayforge.com/roadmap" />
          <meta property="og:title" content="Roadmap - Gateway Forge" />
          <meta property="og:description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />

        </Helmet>

        <h1 style={{margin: '40px auto'}}>Roadmap</h1>

        <Column style={{margin: 10, borderRadius: 10, padding: 10}}>
          <h2>Current Stage: <span style={{color: theme.yellow, marginLeft: 10}}>Alpha</span></h2>
          <ul className='roadmap-list'>
            <li className='roadmap-listitem'>Auto-tagging, commenting, and other document tools</li>
            <li className='roadmap-listitem'>Timelines, calendars, relational graphs, and diplomacy webs</li>
            <li className='roadmap-listitem'>Dynamic relations, custom details, and unlimited offline worldbuilding</li>
            <li className='roadmap-listitem'>Beat sheets, swimlanes, and mind mapping</li>
            <li className='roadmap-listitem'>Evolving maps, track locations and regions across time</li>
            <li className='roadmap-listitem'>Database access, basic integrated sql capabilities</li>
            <li className='roadmap-listitem'>OpenRouter AI integration, context-aware AI assisted worldbuilding</li>
            <li className='roadmap-listitem'>Offline local projects, unlimited private local storage</li>
            <li className='roadmap-listitem'>Export capabilities for manuscripts, documents, and other report formatting</li>
          </ul>
        </Column>

        <Column style={{margin: 10, borderRadius: 10, padding: 10}}>
          <h2>Future Development:</h2>
          <ul className='roadmap-list'>
            <li className='roadmap-listitem'>Local realtime collaboration</li>
            <li className='roadmap-listitem'>Cloud project sync</li>
            <li className='roadmap-listitem'>VTT and campaign management</li>
            <li className='roadmap-listitem'>AI game masters, virtual DnD</li>
            <li className='roadmap-listitem'>Storyboards</li>
            <li className='roadmap-listitem'>More plugins, api integrations, and project enhancements</li>
            <li className='roadmap-listitem'>Always more testing</li>
          </ul>
        </Column>


    </Column>
};











export default Roadmap